export const SCHEMA_NAME = "Bio";

export const FIELDS = {
  BIO_ID: "bioID",
  PIN_NO: "pinNo",
  OTN: "otn",
  L_NAME: "lName",
  F_NAME: "fName",
  M_NAME: "mName",
  SUFFIX: "suffix",
  STREET_1: "street1",
  STREET_2: "street2",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
  MAILING_STREET_1: "mailingStreet1",
  MAILING_STREET_2: "mailingStreet2",
  MAILING_CITY: "mailingCity",
  MAILING_STATE: "mailingState",
  MAILING_ZIP: "mailingZip",
  DOB: "dob",
  AGE_AT_ENTRY: "ageAtEntry",
  SSN: "ssn",
  RACE: "race",
  SEX: "sex",
  HEIGHT: "height",
  WEIGHT: "weight",
  HAIR: "hair",
  EYES: "eyes",
  GLASSES: "glasses",
  HAIR_LENGTH: "hairLength",
  FACIAL_HAIR: "facialHair",
  COMPLEXION: "complexion",
  ALIASES: "aliases",
  DL_NUMBER: "dlNumber",
  LAST_MODIFIED: "lastModified",
  PHONE: "phone",
  DL_STATE: "dlState",
  DECEASED: "deceased",
  DOD: "dod",
  ETHNICITY: "ethnicity",
  EYE_CHARACTERISTICS: "eyeCharacteristics",
  FBI: "fbi",
  SID: "sid",
  SKIN: "skin",
  BUILD: "build",
  TEETH: "teeth",
  COUNTRY: "country",
  PLACE_OF_BIRTH_CITY: "placeOfBirthCity",
  PLACE_OF_BIRTH_STATE: "placeOfBirthState",
  DAYTIME_PHONE: "daytimePhone",
  AGE_1: "age1",
  AGE_2: "age2",
  DOB_SPECIAL: "dobSpecial",
  TITLE: "title",
  PLACE_OF_BIRTH_COUNTRY: "placeOfBirthCountry",
  COUNTRY_OF_CITIZENSHIP: "countryofCitizenship",
  JUVENILE: "juvenile",
  BLOOD_TYPE: "bloodType",
  EMERGENCY_CONTACT: "emergencyContact",
  EMERGENCY_PHONE: "emergencyPhone",
  PHYSICIAN_NAME: "physicianName",
  PHYSICIAN_PHONE: "physicianPhone",
  PRIMARY_LANGUAGE: "primaryLanguage",
  EMERGENCY_ADDRESS: "emergencyAddress",
  EMERGENCY_CONTACT_RELATIONSHIP_ID: "emergencyContactRelationshipID",
  APARTMENT_NUMBER: "apartmentNumber",
  STREET_NUMBER: "streetNumber",
  STREET_SUFFIX: "streetSuffix",
  MAILING_APARTMENT_NUMBER: "mailingApartmentNumber",
  MAILING_STREET_NUMBER: "mailingStreetNumber",
  MAILING_STREET_SUFFIX: "mailingStreetSuffix",
  DL_EXPIRATION: "dlExpiration",
  EMERGENCY_CONTACT_COMMENTS: "emergencyContactComments",
  HAIR_STYLE: "hairStyle",
  POB_TYPE: "pobType",
  POBNCICID: "pobncicid",
  QUESTIONED_IDENTITY: "questionedIdentity",
  CELL_PHONE: "cellPhone",
  FINGERPRINT_CLASSIFICATION: "fingerprintClassification",
  COUNTRY_OF_CITIZENSHIP_ID: "countryOfCitizenshipID",
  ENROLLEE_ID: "enrolleeID",
  DL_SPECIAL: "dlSpecial",
};
